import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g className="pig-body">
			<g className="tail">
				<path className="fill" d="M328.34531,230.82381c3.18512-0.00906,6.37933-0.46693,9.27466-1.50436
					c2.89636-1.00417,5.49231-2.65872,7.08035-4.75273c0.79626-1.04272,1.32193-2.17517,1.55502-3.37589
					c0.12851-0.59923,0.14691-1.2229,0.1217-1.85992c-0.00934-0.31902-0.05569-0.64256-0.10406-0.96915
					c-0.0625-0.30313-0.10736-0.59947-0.19403-0.86557c-0.32053-1.08884-0.87064-1.84404-1.7095-2.36264
					c-0.8439-0.50876-2.04034-0.73933-3.27759-0.5894c-1.2355,0.15498-2.46368,0.68491-3.38245,1.45599
					c-0.92175,0.78217-1.47968,1.77878-1.67093,2.92885c-0.07861,0.5836-0.04861,1.20778,0.0542,1.86798
					c0.14615,0.71489,0.34497,1.4061,0.62265,2.05496c0.56595,1.28967,1.43607,2.41354,2.59875,3.30885
					c2.32608,1.82086,5.67651,2.60555,9.01334,2.63806c3.36151,0.04082,6.80441-0.64862,9.95804-1.91713l0.01764-0.00705
					c0.97873-0.39386,2.091,0.08038,2.48486,1.0591c0.39059,0.97116-0.07458,2.07462-1.03793,2.47603
					c-3.60242,1.50009-7.42484,2.37448-11.36945,2.535c-1.97253,0.05795-3.98038-0.06854-5.98166-0.51758
					c-1.99576-0.43671-4.01065-1.17856-5.83554-2.39993c-0.90665-0.61435-1.76038-1.33882-2.51987-2.16837
					c-0.74716-0.84062-1.38998-1.77676-1.91815-2.76883c-0.51532-0.99838-0.89731-2.04614-1.1846-3.10526
					c-0.27289-1.12587-0.42737-2.3329-0.34698-3.57368c0.17035-2.49089,1.35419-4.95659,3.11835-6.65977
					c1.76089-1.71529,3.9552-2.82932,6.31458-3.31264c2.35254-0.46265,4.97247-0.29735,7.3855,0.88121
					c2.42664,1.16316,4.31076,3.45601,5.19928,5.80428c0.23987,0.58511,0.4057,1.18333,0.56067,1.76416
					c0.13052,0.56924,0.24744,1.14403,0.31421,1.73645c0.1391,1.17754,0.17389,2.3954,0.01816,3.60242
					c-0.28046,2.42085-1.19342,4.74846-2.48285,6.70187c-1.28613,1.96651-2.90793,3.59082-4.65167,4.9314
					c-1.74628,1.34384-3.62006,2.42513-5.55585,3.28391c-3.87329,1.73216-7.96909,2.62772-12.07071,2.9601l-0.00955,0.00075
					c-2.55869,0.20738-4.80115-1.6989-5.00851-4.25758c-0.20764-2.55893,1.69864-4.80138,4.25757-5.00876
					C328.10089,230.82936,328.22888,230.82457,328.34531,230.82381z" />
			</g>
			<path className="fill" d="M139.83638,284.31741c-0.00134,14.89529,5.00095,28.64374,18.18314,42.07855
				c27.51324,23.86151,75.76874,29.80368,114.08922,29.81805c44.94568,0.01685,72.70572-28.40726,75.7645-67.00101
				c2.89749-36.55836-16.22995-80.57831-89.18546-80.547c-36.70749,0.01575-67.23137,5.02946-88.63647,16.02713
				C148.43494,235.79936,139.83841,261.91348,139.83638,284.31741z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/Bodies.js